<template>
  <button
    class="d-block mx-auto"
    :type="type"
    :class="className"
    @click="$emit('obClick')"
  >
    <slot>Button</slot>
  </button>
</template>

<script>
export default {
    name: "Button",
    props: {
      type: {
        type: String,
        default: "button"
      },
      className: {
        type: String,
        default: ''
      }
    }
}
</script>

<style lang="scss" scoped>
    button {
        font-family: $font-family-base;
        @include gradient-primary;
        font-size: 20px;
        padding: 10px;
        color: white;
        border: 0;
        width: 100%;
        border-radius: 25px;
        font-weight: 500;
        max-width: 370px;

        &.outline {
          background: transparent;
          background-color: white;
          color: $primary-color;
          border: 1px solid $primary-color;

          &.dark {
            color: $basic-font-color;
            border-color: $dark-gray;
          }
        }
    }
</style>